export const Constants = {
  HalloweenDate: 'zaterdag 28 oktober',
  FlyerLink:
    'https://docs.google.com/presentation/d/136Ieq1AIWP74xfqfzLipWgDjTYnmgb_inY3DP2ohWLs/edit?fbclid=IwAR1dO8jEdit2Y0eGX6Fc0D7PKx3KsK_Jhf0pOd3jxCQkgaVwrIDNdhugC50#slide=id.p',
  MapLink:
    'https://www.google.com/maps/d/u/0/viewer?mid=117jdVxdqziqWggqLs9I9GkuF0ofHMlw&ll=51.794228095433475%2C4.314066329638306&z=17',
  MapEmbed:
    'https://www.google.com/maps/d/embed?mid=117jdVxdqziqWggqLs9I9GkuF0ofHMlw&ehbc=2E312F&ll=51.79419019410184%2C4.314470812278128&z=16'
}
